<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡组进度奖励</span>
        </div>
        <el-table
          :data="formData"
          border
          style="width: 80%"
        >
          <el-table-column
            prop="id"
            label="ID"
          >
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column
            prop="levelId"
            label="等级"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.levelId" placeholder="等级" />
            </template>
          </el-table-column>
          <el-table-column
            prop="progress"
            label="进度ID"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.progress" placeholder="进度ID" />
            </template>
          </el-table-column>
          <el-table-column
            prop="coin_reward"
            label="金币奖励"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.coin_reward" placeholder="金币奖励" />
            </template>
          </el-table-column>
          <el-table-column
            prop="spin_reward"
            label="体力奖励"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.spin_reward" placeholder="体力奖励" />
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:card-process:save']" style="margin-top: 10px" size="mini" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:card-process:save']" style="margin-top: 10px" size="mini" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { delCardProcess, getCardProcessList, updateCardProcess } from '@/api/config/card-pro'
export default {
  name: 'CardProcess',
  data() {
    return {
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'id': 0,
          'levelId': 0,
          'progress': 0,
          'coin_reward': 0,
          'spin_reward': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateCardProcess({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCardProcessList().then(res => {
        this.formData = res.data
      })
    },
    add() {
      this.formData.push({
        'id': 0,
        'levelId': 0,
        'progress': 0,
        'coin_reward': 0,
        'spin_reward': 0
      })
    },
    del(id, index) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCardProcess({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }

      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
